import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const EditManualStatementEvent = BaseLoanEvent.extend({
  type: z.literal('editManualStatement'),
  principal: z.number(),
  interest: z.number(),
  escrow: z.number(),
  paymentDueId: zodBrandedUuid<PaymentDueId>(),
});
export type EditManualStatementEvent = z.infer<typeof EditManualStatementEvent>;
